
import { Component, Emit, Vue } from 'vue-property-decorator';
@Component({})
export default class ZawatrialSuspended extends Vue {
  @Emit('onLoginWithProvider') onLoginWithProvider(id: string) {}
}
